import { render } from "./S131979.vue?vue&type=template&id=5aa3d5b3"
const script = {}
script.render = render

export default script